import React from "react";
import AddressIconImage from "images/office-building.svg";
import CallIconImage from "images/callicon.svg";
import MailIconImage from "images/mail.svg";

export default class ContactInfo extends React.Component {
  title = "";
  detail = "";
  info = {};

  constructor(props) {
    super(props);
    this.title = props.fieldData.title;
    this.detail = props.fieldData.detail;
    this.info = props.extraData.info;
  }

  render() {
    return (
      <div className="container contact-info">
        <div className="row">
          <div className="col-md-4">
            <div className="single-contact">
              <img src={AddressIconImage} alt="" />
              <h4>Address</h4>
              <p>PO Box 8264 St. Thomas, VI</p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="single-contact">
              <img src={CallIconImage} alt="" />
              <h4>Call Us</h4>
              <p>
                <a href="tel:3406909330"> 340-690-9330 (Inquiries only)</a>
                <br />
                <a href="tel:3407740428"> 340-774-0428 (Dispatch Number)</a>
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="single-contact">
              <img src={MailIconImage} alt="" />
              <h4>Mail Us</h4>
              <p>
                <a href="mailto:kellystaxi@gmail.com">kellystaxi@gmail.com</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
